import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const arrowCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default arrowCommands;
